import { render, staticRenderFns } from "./AgesModule.vue?vue&type=template&id=3658bf12&scoped=true&"
import script from "./AgesModule.vue?vue&type=script&lang=js&"
export * from "./AgesModule.vue?vue&type=script&lang=js&"
import style0 from "./AgesModule.vue?vue&type=style&index=0&id=3658bf12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3658bf12",
  null
  
)

export default component.exports